import { EnvironmentService } from './environmentService';
import SettingsService from './settingsService';

/**
 * @ngdoc service
 * @name phoenix.localizedResources.pxLocalizedResourcesService
 * @description
 * Provides the correct paths to the legal and help files based on the environments language.
 */
export class LocalizedResourcesService {
    public static $inject = [
        'settingsService',
        'pxEnvironmentService'
    ]

    constructor(
        private settingsService:SettingsService,
        private pxEnvironmentService:EnvironmentService
    ) {
    }
    // This service assumes that the legal and help languages in the pxEnvironmentService
    // have already been verified.
    private readonly legalLang = this.pxEnvironmentService.legalLanguage;
    private readonly legalUrlBasePath = this.settingsService.serverLegalPath + (this.legalLang === 'en' ? '' : '/' + this.legalLang);
    
    private readonly termsOfServicePath = `${this.legalUrlBasePath}/terms-of-service/`;
    private readonly privacyPolicyPath = `${this.legalUrlBasePath}/privacy-policy/`;
    private readonly acceptableUsePath = `${this.legalUrlBasePath}/acceptable-use-policy/`;

    private readonly helpLang = this.pxEnvironmentService.helpLanguage;
    private readonly helpPath = this.helpLang === 'en' ? this.settingsService.serverHelpPath :
        this.settingsService.serverHelpPath.replace('/help/', `/help/${this.helpLang}/`);

    /**
     * @ngdoc property
     * @name pxLocalizedResourcesService#termsOfService
     * @propertyOf phoenix.localizedResources.pxLocalizedResourcesService
     * @kind property
     *
     * @description
     * The fully qualified URL to the relevant terms of service page.
     */
    public get termsOfService() {
        return this.termsOfServicePath;
    }
    /**
     * @ngdoc property
     * @name pxLocalizedResourcesService#privacyPolicy
     * @propertyOf phoenix.localizedResources.pxLocalizedResourcesService
     * @kind property
     *
     * @description
     * The fully qualified URL to the relevant privacy policy page.
     */
    public get privacyPolicy() {
        return this.privacyPolicyPath;
    }
    /**
     * @ngdoc property
     * @name pxLocalizedResourcesService#acceptableUse
     * @propertyOf phoenix.localizedResources.pxLocalizedResourcesService
     * @kind property
     *
     * @description
     * The fully qualified URL to the relevant acceptable terms of use page.
     */
    public get acceptableUse() {
        return this.acceptableUsePath;
    }
    /**
     * @ngdoc property
     * @name pxLocalizedResourcesService#help
     * @propertyOf phoenix.localizedResources.pxLocalizedResourcesService
     * @kind property
     *
     * @description
     * The fully qualified URL to the relevant help files.
     */
    public get help() {
        return this.helpPath;
    }
}



// WEBPACK FOOTER //
// ./src/phoenix/services/localizedResourcesService.ts